import confetti from "../../node_modules/canvas-confetti";

(function ($) {
  const confettiCanvas = document.getElementById("confetti-canvas");
  const formConfetti = confetti.create(confettiCanvas, {
    resize: true,
    useWorker: true,
  });

  conditionOptions = [
    {
      id: "Used",
      description:
        "Your item is in good working condition with no major cosmetic damage or modifications. No major scratches or dings are present. May include accessories. The original box is not included.",
    },
    {
      id: "Used With Box",
      description:
        "Your item is in good working condition with no major cosmetic damage. No major scratches or dings are present. May include accessories. The original box is included.",
    },
    {
      id: "Brand New Sealed",
      description:
        "Your item is brand new and sealed in its original box. Includes all parts and accessories.",
    },
  ];

  motherboardModelTemplate = [
    {
      key: "condition",
      header: "What is the condition of your {model}?",
      format: "button",
      options: conditionOptions,
    },
  ];

  gpuModelTemplate = [
    {
      key: "condition",
      type: "meta",
      header: "What is the condition of your {model}?",
      format: "button",
      options: conditionOptions,
    },
    {
      key: "brand",
      type: "static",
      header: "Do you know the brand of your graphics card?",
      subheader: "If you aren't sure, no problem. Pick unknown.",
      format: "button",
      options: [
        { id: "Acer" },
        { id: "AMD" },
        { id: "ASUS" },
        { id: "ASRock" },
        { id: "Dell" },
        { id: "EVGA" },
        { id: "Galax" },
        { id: "Gigabyte" },
        { id: "Gunnir" },
        { id: "HP" },
        { id: "Intel" },
        { id: "Lenovo" },
        { id: "MSI" },
        { id: "Nvidia" },
        { id: "PNY" },
        { id: "PowerColor" },
        { id: "Sapphire" },
        { id: "VisionTek" },
        { id: "XFX" },
        { id: "Zotac" },
        { id: "Other" },
        { id: "Unknown" },
      ],
    },
  ];

  cpuModelTemplate = [
    {
      key: "condition",
      header: "What is the condition of your {model}?",
      format: "button",
      options: conditionOptions,
    },
  ];

  ramModelTemplate = [
    {
      key: "condition",
      header: "What is the condition of your {model}?",
      format: "button",
      options: conditionOptions,
    },
  ];

  storageModelTemplate = [
    {
      key: "condition",
      header: "What is the condition of your {model}?",
      subheader:
        "Make sure you've backed up your drive before sending it in. All drives are wiped during processing according to information security standards.",
      format: "button",
      options: conditionOptions,
    },
  ];

  const categoryConfig = {
    gpu: {
      modelSteps: [
        {
          key: "subcategory",
          type: "static",
          header: "Who is the manufacturer of your GPU?",
          subheader: "How do I figure out my graphics card details?",
          info: "gpu-model-make-modal",
          show_search: true,
          search_placeholder: "Search (Ex: RTX 3070, RX 7800 XT)",
          options: [
            {
              id: "Nvidia GPU",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/nvidia.png",
            },
            {
              id: "AMD GPU",
              image: "https://dandyful.com/wp-content/uploads/2025/02/amd.png",
            },

            {
              id: "Intel GPU",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/intel.png",
            },
          ],
        },
        {
          key: "series",
          type: "meta",
          header: "What is the series of your graphics card?",
          key_dependency: "subcategory",
        },
        {
          key: "model",
          type: "model",
          header: "What is your exact GPU model?",
          subheader:
            "If you have multiple, you'll be able to add a quantity in your offer list later.",
        },
      ],
      attributesTemplate: gpuModelTemplate,
      title: "GPU",
      subtitle: "GPU (Graphics Card)",
      image:
        "https://dandyful.com/wp-content/uploads/2023/05/gpu_front_page.webp",
    },
    cpu: {
      modelSteps: [
        {
          key: "subcategory",
          type: "static",
          header: "Who is the manufacturer of your CPU?",
          subheader: "How do I figure out my exact CPU model?",
          info: "cpu-model-make-modal",
          show_search: true,
          search_placeholder: "Search for your CPU model name",
          options: [
            {
              id: "Intel CPU",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/intel.png",
            },
            {
              id: "AMD CPU",
              image: "https://dandyful.com/wp-content/uploads/2025/02/amd.png",
            },
          ],
        },
        {
          key: "series",
          type: "meta",
          header: "What is the series of your CPU?",
          key_dependency: "subcategory",
        },
        {
          key: "model",
          type: "model",
          header: "What is your exact CPU model?",
          subheader:
            "If you have multiple, you'll be able to add a quantity in your offer list later.",
        },
      ],
      attributesTemplate: cpuModelTemplate,
      title: "CPU",
      subtitle: "CPU",
      image:
        "https://dandyful.com/wp-content/uploads/2023/05/cpu_front_page.webp",
    },
    motherboard: {
      modelSteps: [
        {
          key: "subcategory",
          type: "static",
          show_search: true,
          search_placeholder: "Search for your motherboard chipset name",
          header: "What brand of CPU does your motherboard use?",
          options: [
            {
              id: "Intel",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/intel.png",
            },
            {
              id: "AMD",
              image: "https://dandyful.com/wp-content/uploads/2025/02/amd.png",
            },
          ],
        },
        {
          key: "form_factor",
          type: "static",
          header: "What is the form factor of your motherboard?",
          options: [
            {
              id: "EATX",
              sublabel: '4-8 RAM slots, 2+ PCIe slots, 12" x 13"',
              image: null,
            },
            {
              id: "ATX",
              sublabel:
                'Most common. Usually 4 RAM slots, 2+ PCIe slots, 12" x 9.6"',
              image: null,
            },
            {
              id: "mATX",
              sublabel: '2-4 RAM slots, 2-4 PCIe slots, 9.6" x 9.6"',
              image: null,
            },
            {
              id: "ITX",
              sublabel: '2 RAM slots, 1 PCIe slot, 6.7" x 6.7"',
              image: null,
            },
          ],
        },
        {
          key: "chipset",
          type: "model",
          header: "What is the chipset of your motherboard?",
          subheader:
            "If you have multiple, you'll be able to add a quantity in your offer list later.",
          key_dependency: "subcategory",
        },
      ],
      attributesTemplate: motherboardModelTemplate,
      title: "Motherboard",
      subtitle: "Motherboard",
      image:
        "https://dandyful.com/wp-content/uploads/2025/02/Motherboard_Display.webp",
    },
    storage: {
      modelSteps: [
        {
          key: "subcategory",
          type: "static",
          header: "What type of storage do you want to sell?",
          subheader: "How do I figure out my storage type and capacity?",
          info: "storage-info",
          show_search: true,
          search_placeholder: "Search for your storage type and capacity",
          options: [
            {
              id: "M.2",
              sublabel: "Plugged directly into your computer's motherboard",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/M2_SSD.webp",
            },
            {
              id: "SSD",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/SSD-Transparent-PNG.png",
            },
            {
              id: "HDD",
              image:
                "https://dandyful.com/wp-content/uploads/2025/02/HDD_Thumb.png",
            },
          ],
        },
        {
          key: "model",
          type: "model",
          key_dependency: "subcategory",
          header: "What is the capacity of your storage?",
          subheader:
            "Don't see an exact match? Round down to the nearest size.",
          images: "",
        },
      ],
      attributesTemplate: storageModelTemplate,
      title: "Storage",
      subtitle: "Storage",
      image:
        "https://dandyful.com/wp-content/uploads/2025/02/SSD-Transparent-PNG.png",
    },
    ram: {
      modelSteps: [
        {
          key: "subcategory",
          type: "static",
          header: "What type of RAM do you want to sell?",
          show_search: true,
          search_placeholder:
            "Search for your RAM capacity, type, and generation",
          options: [
            { id: "UDIMM", label: "Desktop RAM (UDIMM)", image: null },
            { id: "RDIMM", label: "Server RAM (RDIMM)", image: null },
            { id: "SODIMM", label: "Laptop RAM (SODIMM)", image: null },
          ],
        },
        {
          key: "generation",
          type: "static",
          header: "What is the generation of your RAM?",
          options: [
            { id: "DDR3", image: null },
            { id: "DDR4", image: null },
            { id: "DDR5", image: null },
          ],
        },
        {
          key: "capacity",
          type: "model",
          header: "What is the total capacity of your RAM?",
          subheader:
            "If you have multiple, you'll be able to add a quantity in your offer list later.",
        },
      ],
      attributesTemplate: ramModelTemplate,
      title: "RAM",
      subtitle: "RAM",
      image:
        "https://dandyful.com/wp-content/uploads/2023/05/ram_front_page.webp",
    },
  };

  class CustomCombobox {
    constructor(inputSelector, resultsContainerSelector) {
      this.input = $(inputSelector);
      this.resultsContainer = $(resultsContainerSelector);
      this.items = []; // Cache API results
      this.skipHide = false; // Flag to prevent hiding when clicking inside results
      this.init();
    }

    // Initialize event listeners
    init() {
      this.input.on("input", () => {
        window.posthog.capture("tradein_page:query_search", {
          query: this.input.val(),
        });
        this.filterResults();
      });
      this.input.on("focus", () => {
        window.posthog.capture("tradein_page:search_start");
        this.showResults();
      });
      this.input.on("blur", () => {
        // Delay to allow mousedown events on the results container to fire
        window.posthog.capture("tradein_page:search_end");
        setTimeout(() => {
          if (!this.skipHide) {
            this.hideResults();
          }
          // Reset the flag after handling the blur
          this.skipHide = false;
        }, 100);
      });

      // When clicking on the results container, set the skipHide flag.
      this.resultsContainer.on("mousedown", () => {
        this.skipHide = true;
      });
    }

    filterResults() {
      const query = this.input.val().trim().toLowerCase();

      // If there is no query, hide the results container and exit.
      if (query === "" || query === null) {
        this.hideResults();
        return;
      }

      let filteredItems = this.items.filter((item) =>
        item.name.toLowerCase().includes(query)
      );
      // Limit the results to 10 items
      filteredItems = filteredItems.slice(0, 10);
      this.updateResults(filteredItems);
      // Show the results when there is a query
      this.showResults();
    }

    // Show results container (transitions removed for simplicity)
    showResults() {
      // If there is no query, hide the results container and exit.
      if (this.input.val().trim() === "" || this.input.val().trim() === null) {
        this.hideResults();
        return;
      }

      this.resultsContainer.removeClass("hidden");
    }

    // Hide results container
    hideResults() {
      this.resultsContainer.addClass("hidden");
    }

    // Update results container with filtered items
    updateResults(items) {
      this.resultsContainer.empty();
      if (items.length === 0) {
        this.resultsContainer.append(
          `<div class="p-2 text-gray-500">No results found.</div>`
        );
        return;
      }

      // Group items by tags
      const groupedItems = items.reduce((groups, item) => {
        const tag = (item.metadata && item.metadata.subcategory) || "Other";
        if (!groups[tag]) groups[tag] = [];
        groups[tag].push(item);
        return groups;
      }, {});

      // Render grouped items
      Object.entries(groupedItems).forEach(([tag, group]) => {
        this.resultsContainer.append(
          `<div class="text-sm font-medium text-gray-600">${tag}</div>`
        );
        group.forEach((item) => {
          const itemElement = $(`
                <button type="button" class="model-btn flex items-center p-2 cursor-pointer hover:bg-gray-100 rounded w-full"
                             data-key="id" data-value="${item.id}" data-name="${item.name}">
                      <span class="text-sm text-gray-800">${item.name}</span>
                </button>
          `);
          itemElement.on("click", () => {
            window.posthog.capture("tradein_page:search_select", {
              id: item.id,
              name: item.name,
            });
          });
          this.resultsContainer.append(itemElement);
        });
      });
    }
  }

  class DynamicStepper {
    constructor(container, config) {
      this.container = $(container);
      this.pendingQuotes = [];
      this.config = config;
      this.formState = this.getInitialState();
      this.historyStack = [];
      this.currentStep = 0;
      this.isAttributeStep = false;
      this.previousStep = null; // Track previous step
      this.cache = {};
      this.init();
    }

    getInitialState() {
      return {
        category: null,
        name: "",
        id: "",
        attributes: {},
      };
    }

    init() {
      this.attachButtonHandlers();
      if (!this.formState.category) {
        this.renderStep();
      }
    }

    attachButtonHandlers() {
      $(document).on("click", ".category-btn", (e) =>
        this.handleCategorySelection(e)
      );
      $(document).on("click", ".step-btn", (e) => this.handleStepSelection(e));
      $(document).on("click", ".model-btn", (e) =>
        this.handleModelSelection(e)
      );
      $(document).on("click", ".attribute-btn", (e) =>
        this.handleAttributeSelection(e)
      );
      $(document).on("click", ".generate-offer-btn", (e) =>
        this.generateOffer()
      );

      $(document).on("click", "#quote-list-btn", (e) =>
        HSOverlay.open("#quote-display-modal")
      );

      $(document).on("click", ".add-item-btn", (e) =>
        this.addItemToQuoteList(e)
      );

      $("#back-btn").on("click", () => this.handleBackButtonClick());
      $("#reset-btn").on("click", () => {
        this.resetForm();
        this.renderStep();
      });
    }

    async handleCategorySelection(e) {
      window.posthog.capture("tradein_page:category_select", {
        category: this.formState.category,
      });
      this.storeCurrentState();
      this.formState.category = $(e.target).closest("button").data("value");
      this.currentStep = 1;
      !this.cache[this.formState.category]
        ? await this.loadCategoryData(this.formState.category)
        : null;
      this.renderStep();
    }

    async loadCategoryData(category) {
      try {
        this.showLoadingState();
        const response = await fetch(
          `https://dandyful.com/wp-json/api/v1/get-products/?category=${category.toLowerCase()}`
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch data for category: ${category}`);
        }
        const data = await response.json();
        this.cache[category] = data;
      } catch (error) {
        console.error("Error loading category data:", error);
        // Handle error appropriately, e.g., show an error message to the user
      } finally {
      }
    }

    transitionContent(newContentCallback, duration = 100) {
      this.container.fadeOut(duration, () => {
        // Update the content via the callback
        newContentCallback();
        // Then fade in the container with the new content
        this.container.fadeIn(duration);
      });
    }

    showLoadingState() {
      // Display a loading indicator to the user
      $("#loading-skeleton").show();
      $("#stepper").children().hide();
    }

    hideLoadingState() {
      // Hide the loading indicator
      $("#loading-skeleton").hide();
      $("#stepper").children().stop(true, true).show();
    }

    addItemToQuoteList(e) {
      this.pendingQuotes.push(this.formState);
      $("#quote-list-btn").removeAttr("hidden");
      $("#quote-list-btn").text(
        "View pending quote list (" +
          this.pendingQuotes.length +
          " item" +
          (this.pendingQuotes.length > 1 ? "s" : "") +
          ")"
      );

      this.resetForm();

      this.handleCategorySelection(e);

      console.log(this);
    }

    handleStepSelection(e) {
      this.storeCurrentState();

      const { key, value } = $(e.target).closest("button").data();

      window.posthog.capture("tradein_page:step_select", {
        step: key,
        value: value,
      });

      // Ensure all non-category selections go inside attributes
      if (key !== "category") {
        this.formState.attributes[key] = value;
      } else {
        this.formState[key] = value;
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          this.currentStep++;
          this.renderStep();
        });
      }, 10);
    }

    // Utility function to determine if a key belongs inside attributes
    isMetaStep(key) {
      const category = this.formState.category;
      return this.config[category].modelSteps.some(
        (step) => step.key === key && step.type === "meta"
      );
    }

    handleModelSelection(e) {
      const modelId = $(e.target).closest("button").data("value");
      const name = $(e.target).closest("button").data("name") || "";
      const sku = $(e.target).closest("button").data("sku") || "";

      window.posthog.capture("tradein_page:model_select", {
        model: name,
        id: modelId,
      });

      window.dataLayer = window.dataLayer || [];
      // Clear ecommerce dataLayer
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: "USD",
          items: [
            {
              item_id: sku || modelId,
              item_name: name,
            },
          ],
        },
      });
      this.storeCurrentState();
      this.formState.id = $(e.target).closest("button").data("value");
      this.formState.name = $(e.target).closest("button").data("name") || "";
      this.isAttributeStep = true;
      this.currentStep = this.config[this.formState.category].modelSteps.length;
      this.renderStep();
    }

    handleAttributeSelection(e) {
      this.storeCurrentState();
      const { key, value } = $(e.target).closest("button").data();
      this.formState.attributes[key] = value;

      window.posthog.capture("tradein_page:attribute_select", {
        attribute: key,
        value: value,
      });

      if (
        this.currentStep <
        this.config[this.formState.category].attributesTemplate.length +
          this.config[this.formState.category].modelSteps.length
      ) {
        this.currentStep++;
        this.renderStep();
      } else {
        this.finishForm();
      }
    }

    handleBackButtonClick() {
      window.posthog.capture("tradein_page:back_button_click");
      if (this.historyStack.length > 0) {
        const lastState = this.historyStack.pop();
        this.formState = { ...lastState.formState };
        this.currentStep = lastState.currentStep;
        this.isAttributeStep = lastState.isAttributeStep;
        this.previousStep = lastState.previousStep;

        if (
          this.isAttributeStep &&
          this.currentStep <
            this.config[this.formState.category].modelSteps.length
        ) {
          this.isAttributeStep = false;
        }

        this.renderStep();
      } else {
        this.resetForm();
        this.renderStep();
      }
    }

    storeCurrentState() {
      this.historyStack.push({
        formState: JSON.parse(JSON.stringify(this.formState)), // Deep clone to prevent mutation
        currentStep: this.currentStep,
        isAttributeStep: this.isAttributeStep,
        previousStep: this.previousStep,
      });
    }

    resetForm() {
      this.formState = this.getInitialState();
      this.currentStep = 0;
      this.historyStack = [];
      this.isAttributeStep = false;
      this.previousStep = null;
      $("#offer-display").hide();
      $("#form-top-wrapper").show();
      $("#form-select-window").addClass("h-[600px]"); //Lock height
      $("#form-interior-wrapper").addClass("h-100");
    }

    renderStep() {
      this.transitionContent(() => {
        this.renderBreadcrumbs();
        this.hideLoadingState();
        $("#form-top-wrapper").show();
        this.container.empty();
        this.container.scrollTop(0);
        this.renderSubheader();
        if (this.currentStep === 0) {
          $("#back-btn").hide();
          this.renderCategorySelection();
        } else {
          $("#back-btn").show();
          if (this.isAttributeStep) {
            this.renderAttributeStep();
          } else {
            const steps = this.config[this.formState.category].modelSteps;
            const step = steps[this.currentStep - 1];
            $("#form-header").text(step.header);

            if (step.show_search) {
              this.renderSearchBar(step);
            }
            if (step.type === "model") {
              this.renderModelStep();
            } else if (step.type === "static") {
              this.renderStaticStep(step);
            } else if (step.type === "meta") {
              this.renderMetaStep(step);
            }
          }
        }
      });
    }

    renderBreadcrumbs() {
      const breadcrumbContainer = $("#breadcrumb-container");
      breadcrumbContainer.empty();

      let breadcrumbs = [];

      // Start by adding category if it exists
      if (this.formState.category) {
        const categoryTitle =
          this.config[this.formState.category].title || this.formState.category;
        breadcrumbs.push({ label: categoryTitle, key: "category" });
      }

      // Process the historyStack in **sequential order** to build breadcrumbs
      this.historyStack.forEach((entry) => {
        if (
          entry.formState.name &&
          !breadcrumbs.some((b) => b.key === "model")
        ) {
          breadcrumbs.push({ label: entry.formState.name, key: "model" });
        }
        Object.entries(entry.formState.attributes).forEach(([key, value]) => {
          if (!breadcrumbs.some((b) => b.key === key)) {
            breadcrumbs.push({ label: value, key });
          }
        });
      });

      // Append current selection only if it's not redundant
      if (this.formState.name && !breadcrumbs.some((b) => b.key === "model")) {
        breadcrumbs.push({ label: this.formState.name, key: "model" });
      }
      Object.entries(this.formState.attributes).forEach(([key, value]) => {
        if (!breadcrumbs.some((b) => b.key === key)) {
          breadcrumbs.push({ label: value, key });
        }
      });

      // Render Breadcrumbs
      breadcrumbs.forEach((crumb, index) => {
        breadcrumbContainer.append(
          `<span class="breadcrumb-item" data-index="${index}">${crumb.label}</span>` +
            (index < breadcrumbs.length - 1 ? " &gt; " : "")
        );
      });
    }

    renderSubheader() {
      $("#form-subheader")
        .removeClass("hover:underline cursor-pointer")
        .off("click");
      if (!this.formState.category) {
        $("#form-subheader").text("Let's start by selecting a category.");
        return;
      }

      if (this.isAttributeStep) {
        const modelStepCount =
          this.config[this.formState.category].modelSteps.length;
        const attributeIndex = this.currentStep - modelStepCount;

        const hasSubheader =
          attributeIndex <
            this.config[this.formState.category].attributesTemplate.length &&
          this.config[this.formState.category].attributesTemplate[
            attributeIndex
          ].subheader !== undefined;

        hasSubheader
          ? $("#form-subheader").text(
              this.config[this.formState.category].attributesTemplate[
                attributeIndex
              ].subheader
            )
          : $("#form-subheader").text("");

        return;
      }

      const steps = this.config[this.formState.category].modelSteps;
      const step = steps[this.currentStep - 1];

      if (!step) {
        console.warn("Step not found:", this.currentStep - 1);
        $("#form-subheader").text("");
        return;
      }

      if (step.info) {
        $("#form-subheader").addClass("hover:underline cursor-pointer");
        $("#form-subheader").text("🛈 " + step.subheader);
        $("#form-subheader").on("click", function (e) {
          e.preventDefault();
          HSOverlay.open("#" + step.info);
        });
        return;
      }

      step.subheader
        ? $("#form-subheader").text(step.subheader)
        : $("#form-subheader").text("");
    }

    renderSearchBar(step) {
      this.container.append(`
        <div id="combobox-wrapper" class="relative inline-block w-full">
            <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-3.5">
            <svg class="shrink-0 size-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.3-4.3"></path>
            </svg>
          </div>
          <input id="combobox-input" class="py-3 ps-10 pe-4 block w-full border-gray-200 rounded-lg" 
            type="text" placeholder="${
              step.search_placeholder || "Search for your model name"
            }" autocomplete="off">
            <div id="combobox-results" class="p-4 absolute z-50 max-h-60 overflow-auto bg-white border border-gray-200 rounded-md shadow-sm hidden mt-2 w-full [&::-webkit-scrollbar]:w-2
            [&::-webkit-scrollbar-track]:bg-gray-100
            [&::-webkit-scrollbar-thumb]:bg-gray-300"></div>
        </div>
        <div class="py-3 flex items-center text-sm text-gray-400 before:flex-1 before:border-t before:border-gray-200 before:me-6 after:flex-1 after:border-t after:border-gray-200 after:ms-6">OR choose a ${
          step.key
        }</div>
      `);

      const combobox = new CustomCombobox(
        "#combobox-input",
        "#combobox-results"
      );
      combobox.items = this.cache[this.formState.category];
    }

    renderStaticStep(step) {
      this.container.append(`
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 w-full">
          ${step.options
            .map(
              (option) => `
                <button class="group step-btn font-medium aspect-square p-4 rounded-md border border-gray-200 bg-white text-gray-800 flex flex-col items-center justify-center hover:border-brand-500 focus:outline-none focus:shadow-md focus:border-brand-500 transition " 
                data-key="${step.key}" data-value="${
                typeof option === "object" ? option.id : option
              }">
                  ${
                    option.image
                      ? `<img src="${option.image}" alt="${option.id}" class="object-contain w-full h-[75%] pb-2">`
                      : ""
                  }
                  <span class="group-hover:text-brand-500">${
                    typeof option === "object" && option.label
                      ? option.label
                      : typeof option === "object"
                      ? option.id
                      : option
                  }</span>
                </button>
              `
            )
            .join("")}
        </div>
      `);
    }

    renderModelStep() {
      const filteredItems = this.cache[this.formState.category] || [];

      if (!filteredItems.length) {
        console.warn("No models available for filtering.");
        this.container.html(
          `<div class="text-gray-500">No models found.</div>`
        );
        return;
      }

      // Extract valid attribute keys from the dataset
      const validAttributeKeys = new Set();
      filteredItems.forEach((item) => {
        if (item.metadata) {
          Object.keys(item.metadata).forEach((key) =>
            validAttributeKeys.add(key)
          );
        }
      });

      // Ensure filtering only considers relevant attributes
      const filteredAttributes = Object.entries(this.formState.attributes)
        .filter(([key]) => validAttributeKeys.has(key)) // Ignore attributes that don't exist in dataset
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});

      // Now filter items based on the cleaned attributes
      const matchingModels = filteredItems
        .filter((item) => {
          return Object.entries(filteredAttributes).every(([key, value]) => {
            return item.metadata?.[key] === value;
          });
        })
        .sort((a, b) => {
          const extractFirstNumber = (str) => {
            const match = str.match(/\d+/);
            return match ? parseInt(match[0], 10) : Infinity;
          };

          const numberA = extractFirstNumber(a.name);
          const numberB = extractFirstNumber(b.name);

          if (numberA !== numberB) {
            return numberA - numberB;
          }

          return a.name.localeCompare(b.name);
        });

      if (!matchingModels.length) {
        console.warn(
          "No models match the selected attributes:",
          filteredAttributes
        );
        this.container.html(
          `<div class="text-gray-500">No matching models found.</div>`
        );
        return;
      }

      // Render matching models
      this.container.html(`
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              ${matchingModels
                .map(
                  (item) => `
                <button class="model-btn group text-start flex flex-col items-center justify-center bg-white border border-gray-200 shadow-sm rounded-lg hover:shadow-md focus:outline-none focus:shadow-md focus:border-brand-500 transition-all p-4 hover:border-brand-500" 
                        data-key="id" data-value="${item.id}" data-name="${item.name}" data-sku="${item.sku}">
                  <span class="font-medium text-gray-800 group-hover:text-brand-500">${item.name}</span>
                </button>
              `
                )
                .join("")}
          </div>
      `);
    }

    renderAttributeStep() {
      const category = this.formState.category;
      const attributes = this.config[category].attributesTemplate;

      if (!attributes || attributes.length === 0) {
        console.warn(`No attributes found for category: ${category}`);
        this.finishForm(); // Skip attribute step if none exist
        return;
      }

      // Calculate the correct attribute index based on the step count
      const modelStepCount = this.config[category].modelSteps.length;
      const attributeIndex = this.currentStep - modelStepCount;

      if (attributeIndex < 0 || attributeIndex >= attributes.length) {
        this.finishForm(); // If out of bounds, proceed to form completion
        return;
      }

      const currentAttribute = attributes[attributeIndex];

      // Update the header text: if a model is selected, substitute the placeholder.
      let headerText = currentAttribute.header;
      if (this.formState.name && this.formState.name.trim() !== "") {
        // If the header contains a placeholder "{model}", replace it.
        if (headerText.indexOf("{model}") !== -1) {
          headerText = headerText.replace("{model}", this.formState.name);
        } else {
          // Otherwise, you can choose to append the model name.
          headerText += ` (${this.formState.name})`;
        }
      }
      $("#form-header").text(headerText);

      const hasDescription = currentAttribute.options.some(
        (option) => option.description
      );

      // Render the attribute selection buttons accordingly
      if (hasDescription) {
        this.container.html(`

          <div class="flex flex-col gap-4 w-full">
            ${currentAttribute.options
              .map(
                (option) => `
                  <button class="attribute-btn group text-start p-4 w-full rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:border-brand-500 focus:outline-none focus:shadow-md focus:border-brand-500 transition" 
                          data-key="${currentAttribute.key}" data-value="${
                  option.id
                }">
                    <span class="font-medium text-lg pe-2 group-hover:text-brand-500">${
                      option.label ? option.label : option.id
                    }</span>
                    ${
                      option.description
                        ? `<span class="text-sm text-gray-600">${option.description}</span>`
                        : ""
                    }
                  </button>
                `
              )
              .join("")}
          </div>
        `);
      } else {
        this.container.html(`
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4 w-full">  
            ${currentAttribute.options
              .map(
                (option) => `
                  <button class="attribute-btn group p-4 w-full rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:border-brand-500 focus:outline-none focus:shadow-md focus:border-brand-500 transition" 
                          data-key="${currentAttribute.key}" data-value="${
                  option.id
                }">
                    <span class="font-medium group-hover:text-brand-500">${
                      option.label ? option.label : option.id
                    }</span>
                  </button>
                `
              )
              .join("")}
          </div>
        `);
      }
    }

    renderCategorySelection() {
      $("#form-header").text("Generate your offers here.");
      $("#form-subheader").text("Let's start by selecting a category.");
      let categories = Object.keys(this.config);

      // Move the matched category to the front of the list
      if (
        this.formState.category &&
        categories.includes(this.formState.category)
      ) {
        categories = categories.filter((c) => c !== this.formState.category);
        categories.unshift(this.formState.category);
      }

      const categoryButtons = categories
        .map((category) => {
          const isHighlighted =
            category === this.formState.category
              ? "border-brand-500 border-2"
              : "";

          return `
      <button class="category-btn group relative aspect-square rounded-md overflow-hidden border bg-white shadow-sm hover:border-brand-500 transition ${
        isHighlighted !== "" ? isHighlighted : "border-gray-200"
      }" 
      data-value="${category}">

      <img src="${this.config[category].image}" alt="${category}"
         class="absolute inset-0 w-full h-full object-contain px-4 pt-4 pb-10">

      <div class="absolute bottom-0 left-0 w-full bg-gradient-to-t from-white via-white/90 to-transparent">
        <span class="block text-center font-medium text-gray-800 group-hover:text-brand-500 p-2">
          Sell ${this.config[category].subtitle || category}
        </span>
      </div>

    </button>`;
        })
        .join("");

      this.container.append(`
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 w-full">
          ${categoryButtons}
          <a href="https://dandyful.com/custom-quote" class="group relative aspect-square rounded-md overflow-hidden border bg-white shadow-sm hover:border-brand-500 transition border-gray-200" 
          data-value="custom">
            <img src="https://dandyful.com/wp-content/uploads/2023/07/cropped-Favicon.png" alt="favicon" class="absolute inset-0 w-full h-full object-contain px-4 pt-4 pb-10">
            <div class="absolute bottom-0 left-0 w-full bg-gradient-to-t from-white via-white/90 to-transparent">
              <span class="block text-center font-medium text-gray-800 group-hover:text-brand-500 p-2">
                Sell Whole Computer
              </span>
            </div>
          </a>
          <a href="https://dandyful.com/custom-quote" class="group relative aspect-square rounded-md overflow-hidden border bg-white shadow-sm hover:border-brand-500 transition border-gray-200" 
          data-value="custom">
            <img src="https://dandyful.com/wp-content/uploads/2023/07/cropped-Favicon.png" alt="favicon" class="absolute inset-0 w-full h-full object-contain px-4 pt-4 pb-10">
            <div class="absolute bottom-0 left-0 w-full bg-gradient-to-t from-white via-white/90 to-transparent">
                <span class="block text-center font-medium text-gray-800 group-hover:text-brand-500 p-2">
                  Sell Other Electronics
                </span>
              </div>
          </a>
        </div>
      `);
    }

    renderMetaStep(step) {
      const dependencyKey = step.key_dependency;
      const dependencyValue = this.formState.attributes[dependencyKey]; // FIXED: Check in attributes

      if (!dependencyValue) {
        console.error(
          `Error: Dependency "${dependencyKey}" is missing in formState.attributes.`
        );
        return;
      }

      // Get filtered items from cache
      const filteredItems = this.cache[this.formState.category] || [];
      const validItems = filteredItems.filter(
        (item) => item.metadata?.[dependencyKey] === dependencyValue
      );

      // Extract unique options for the current step key
      const uniqueOptions = [
        ...new Set(validItems.map((item) => item.metadata?.[step.key])),
      ]
        .filter(Boolean)
        .sort((a, b) => {
          const extractFirstNumber = (str) => {
            const match = str.match(/\d+/);
            return match ? parseInt(match[0], 10) : Infinity;
          };

          const numberA = extractFirstNumber(a);
          const numberB = extractFirstNumber(b);

          if (numberA !== numberB) {
            return numberA - numberB;
          }

          return a.localeCompare(b);
        });

      if (uniqueOptions.length === 0) {
        console.error(
          `Error: No valid options found for "${step.key}" with dependency "${dependencyKey}" = "${dependencyValue}".`
        );
        return;
      }

      this.container.html(`
        <div class="grid grid-cols-2 gap-4">
          ${uniqueOptions
            .map(
              (option) => `
              <button class="step-btn group font-medium flex flex-col items-center bg-white border border-gray-200 shadow-sm rounded-lg hover:shadow-md focus:outline-none focus:shadow-md focus:border-brand-500 transition-all justify-between p-4 hover:border-brand-500" 
                  data-key="${step.key}" data-value="${option}">
                <span class="text-sm text-gray-800">${option}</span>
              </button>`
            )
            .join("")}
        </div>
      `);
    }

    showOfferLoadingState() {
      // Display a loading indicator to the user
      $("#offer-loading").show();
      $("#back-btn").prop("disabled", true);
      $("#stepper").children().hide();
    }

    hideOfferLoadingState() {
      // Hide the loading indicator
      $("#offer-loading").hide();
      $("#back-btn").prop("disabled", false);
      $("#stepper").children().show();
    }

    finishForm() {
      console.log("finishForm: Start", this);
      $("#form-top-wrapper").hide();
      $("#form-header").text("");
      $("#form-subheader").text("");
      this.container.empty();

      const self = this;

      // --- Declare affectedItem here, in the finishForm scope ---
      let affectedItem = null; 

      self.showOfferLoadingState();
      console.log("finishForm: showOfferLoadingState called");
      window.posthog.capture("tradein_page:generate_offer_start");

      $.ajax({
        type: "post",
        url: $("#df-ajax-url").val(),
        data: {
          action: "woocommerce_ajax_add_to_cart",
          nonce: $("#df-ajax-nonce").val(),
          product_id: self.formState.id,
          quantity: 1,
          attributes: self.formState.attributes,
        },
        success: function (response) {
          console.log("finishForm AJAX: Success callback start", response);

          // No need to declare affectedItem here anymore

          if (response && response.success && response.data) {
            const ajaxData = response.data;
            const updatedItemKey = ajaxData.updated_item_key || null;
            const cartContents = Array.isArray(ajaxData.contents)
              ? ajaxData.contents
              : [];

            console.log(
              "finishForm AJAX: PHP reported success. Key:",
              updatedItemKey,
              "Contents count:",
              cartContents.length
            );
            $(document).trigger("addToCartEvent", ajaxData);
            console.log("addToCartEvent triggered with ajaxData.");

            try {
              if (updatedItemKey && cartContents.length > 0) {
                // --- Assign value to the higher-scoped affectedItem ---
                affectedItem = cartContents.find(
                  (item) => item.key === updatedItemKey
                );
              }

              if (affectedItem) {
                // Check if the assignment was successful
                console.log(
                  "finishForm AJAX: Success - Affected item found:",
                  affectedItem.name,
                  affectedItem
                );
                window.posthog.capture("tradein_page:generate_offer_success", {
                  item: affectedItem,
                });
                $("#offer-display-title").text(
                  `Tada! Your instant ${affectedItem.name ?? "item"} offer is:`
                );
                const offerValue = affectedItem.offer ?? 0;
                $("#instant-offer-amount").text(`$${Math.round(offerValue)}`);
              } else {
                console.error(
                  "finishForm AJAX: Success - PHP success, but item not found with key:",
                  updatedItemKey,
                  "in",
                  cartContents
                );
                $("#offer-display-title").text(
                  "Offer processed, but details unavailable."
                );
                $("#instant-offer-amount").text("");
                window.posthog.capture("tradein_page:generate_offer_error", {
                  reason: "Affected item not found despite PHP success",
                  received_key: updatedItemKey,
                });
                // affectedItem remains null
              }
            } catch (e) {
              console.error(
                "finishForm AJAX: Success - Error processing successful response:",
                e,
                response
              );
              $("#offer-display-title").text("Error processing offer data.");
              $("#instant-offer-amount").text("");
              window.posthog.capture("tradein_page:generate_offer_error", {
                reason: "JS exception during success callback",
                error_message: e.message,
              });
              // affectedItem remains null
            }
          } else {
            console.error(
              "finishForm AJAX: Success callback - PHP reported failure or response format unexpected.",
              response
            );
            let errorMessage = "Could not generate offer. Please try again.";
            // ... (error message extraction logic remains the same) ...
            if (response && response.data) {
              if (
                Array.isArray(response.data.notices) &&
                response.data.notices.length > 0
              ) {
                let tempDiv = document.createElement("div");
                tempDiv.innerHTML = response.data.notices[0];
                errorMessage =
                  tempDiv.textContent ||
                  tempDiv.innerText ||
                  "Offer generation failed.";
              } else if (typeof response.data === "string") {
                errorMessage = response.data;
              }
            }
            $("#offer-display-title").text(errorMessage);
            $("#instant-offer-amount").text("");
            window.posthog.capture("tradein_page:generate_offer_error", {
              reason: "AJAX response indicates PHP failure",
              response: response,
            });
            // affectedItem remains null
          }

          console.log("finishForm AJAX: Success callback end");
        },

        error: function (jqXHR, textStatus, errorThrown) {
          // Error handler remains the same
          console.error(
            "finishForm AJAX: Error callback (AJAX level)",
            textStatus,
            errorThrown,
            jqXHR.responseText
          );
          window.posthog.capture("tradein_page:generate_offer_error", {
            reason: "AJAX call failed (Network/Server Error)",
            status: textStatus,
            error: errorThrown,
          });
          self.hideOfferLoadingState();
          $("#offer-display-title").text(
            "Network error. Please check connection and try again."
          );
          $("#instant-offer-amount").text("");
          $("#offer-display").show();
          $("#back-btn").show();
          // Note: affectedItem remains null here as well
        },

        complete: function (jqXHR, textStatus) {
          console.log(
            "finishForm AJAX: Complete callback start. Status:",
            textStatus
          );

          if (textStatus === "success" && affectedItem) {
            console.log("finishForm AJAX: Complete - Success path identified.");
            // Success Path UI Transitions (setTimeout, confetti, etc.)
            setTimeout(function () {
              console.log(
                "finishForm AJAX: Complete - setTimeout start (Success path)"
              );
              $("#back-btn").hide();
              self.hideOfferLoadingState();
              console.log(
                "finishForm AJAX: Complete - hideOfferLoadingState called"
              );
              self.transitionContent(() => {
                console.log(
                  "finishForm AJAX: Complete - transitionContent callback start"
                );
                $("#form-select-window").removeClass("h-[600px]");
                $("#form-interior-wrapper").removeClass("h-100");
                $("#offer-display").show();
                console.log(
                  "finishForm AJAX: Complete - transitionContent - #offer-display shown"
                );
                if (typeof formConfetti === "function") {
                  formConfetti({
                    /* ... */
                  });
                  console.log(
                    "finishForm AJAX: Complete - transitionContent - confetti called"
                  );
                } else {
                  console.error(
                    "finishForm AJAX: Complete - transitionContent - formConfetti is not defined!"
                  );
                }
                console.log(
                  "finishForm AJAX: Complete - transitionContent callback end"
                );
              });
              console.log("finishForm AJAX: Complete - setTimeout end");
            }, 3000);
          } else {
            // Failure Path Cleanup
            console.log(
              "finishForm AJAX: Complete - Failure path identified (AJAX Status:",
              textStatus,
              ", AffectedItem Found:",
              !!affectedItem,
              ")"
            );
            self.hideOfferLoadingState(); 
            $("#offer-display").show(); 
            $("#back-btn").show(); 
            console.log(
              "finishForm AJAX: Complete - Showing #back-btn on failure path."
            );
          }
          console.log("finishForm AJAX: Complete callback end");
        }, 
      }); 
    } 

    //   finishForm() {
    //     $("#form-header").text(
    //       `Would you like to add more devices befre generating your offer?`
    //     );
    //     $("#form-subheader").text(
    //       `Bundling additional items will increase your offer.`
    //     );

    //     const categoryButtons = Object.keys(this.config)
    //       .map((category) => {
    //         const image = this.config[category].image
    //           ? `<img src="${this.config[category].image}" alt="${category}" class="size-10 object-contain pe-2">`
    //           : "";
    //         return `
    //           <button class="add-item-btn group font-medium flex items-center justify-center p-2 rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm
    //             hover:border-brand-500 focus:outline-none focus:shadow-md focus:border-brand-500 transition" data-value="${category}">
    //             ${image}
    //             <span class="group-hover:text-brand-500">Add ${
    //               this.config[category].subtitle || category
    //             }</span>
    //           </button>`;
    //       })
    //       .join("");

    //     this.container.append(`
    //     <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
    //        <button class="generate-offer-btn group text-start flex flex-col items-center justify-center bg-white border border-gray-200 shadow-sm rounded-lg hover:shadow-md focus:outline-none focus:shadow-md focus:border-brand-500 transition-all p-4 hover:border-brand-500">
    //         <span class="font-medium text-gray-800 group-hover:text-brand-500">That's all, generate my instant offer</span>
    //       </button>
    //       ${categoryButtons}
    //     </div>
    //     `);
    //   }
  }

  $(document).ready(async function () {
    const pathSegments = window.location.pathname.split("/");
    let formStartingCategory = pathSegments[2]
      ? pathSegments[2].toLowerCase()
      : "";

    if (pathSegments[2]) {
      // Special case handling for /sell/graphics-card
      if (pathSegments[2].toLowerCase() === "graphics-card") {
        formStartingCategory = "gpu";
      }
    }

    const stepper = new DynamicStepper("#stepper", categoryConfig);

    const categoryMatch = Object.keys(stepper.config).find(
      (key) => key.toLowerCase() === formStartingCategory
    );

    if (categoryMatch) {
      stepper.storeCurrentState();
      stepper.formState.category = categoryMatch;
      stepper.currentStep = 1;
      !stepper.cache[stepper.formState.category]
        ? await stepper.loadCategoryData(stepper.formState.category)
        : null;
      stepper.renderStep();
    }
  });
})(jQuery);
